import { useEffect } from 'react'

import { BOX_PRODUCT_TYPE } from 'artkive/stores/product.constants'
import { initiateCheckout } from 'artkive/utils/tracker'

const useInitiateCheckoutTracking = ({ price, email, fullName, productId, product = BOX_PRODUCT_TYPE }) => {
  useEffect(() => {
    if (!price?.total) return

    const timer = setTimeout(() => {
      initiateCheckout({
        amount: price.total,
        discount: price.promo_discount,
        email,
        name: fullName || undefined,
        product,
        productId,
        promo: price.promo_discount_details?.code,
        currency: price.currency_code,
      })
    }, 1500)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [price?.total]) // NOTE: only run when price is fetched
}

export default useInitiateCheckoutTracking
